import React from 'react';
import { FrownOutlined } from '@ant-design/icons';
import useHeaderHeight from '@/hooks/useHeaderHeight';
import { PAGE_TITLES } from '@/constants/appConfig';
import {
  ErrorPageContainer,
  MessageBox,
  IconWrapper,
  Title,
  Description,
} from './styles/ErrorPage.styles';

/**
 * PageNotFound Component (404)
 * Displays when a user navigates to a non-existent route
 *
 * @component
 * @return {JSX.Element} 404 error page
 */
const PageNotFound = () => {
  document.title = PAGE_TITLES.PAGE_NOT_FOUND;

  const headerHeight = useHeaderHeight();

  if (headerHeight === null) return null;

  return (
    <ErrorPageContainer headerHeight={headerHeight}>
      <MessageBox>
        <IconWrapper color="#d4380d">
          <FrownOutlined />
        </IconWrapper>
        <Title>Page Not Found</Title>
        <Description>
          The page you&apos;re looking for doesn&apos;t exist or may have been
          moved.
        </Description>
      </MessageBox>
    </ErrorPageContainer>
  );
};

export default PageNotFound;
